import { Message, Sender } from 'services/conversations/types';
import { add, isBefore, parseISO } from 'date-fns';

export const checkLastProspectMessageIsWithin24Hours = (
  messages: Message[]
) => {
  // Filter the messages sent by PROSPECT
  const prospectMessages = messages.filter(
    (message) => message.sender === Sender.PROSPECT
  );

  if (!prospectMessages.length) return false;

  // Sort the messages by updatedAt field in descending order to get the latest message
  prospectMessages.sort(
    (a, b) => parseISO(b.updatedAt).getTime() - parseISO(a.updatedAt).getTime()
  );

  // Extract the updatedAt from the latest message
  const latestUpdatedAt = parseISO(prospectMessages[0].updatedAt);

  // Get the date 24 hours from now
  const date24HoursAfterLatestMessage = add(latestUpdatedAt, { hours: 24 });

  // Check if current time is within the 24h window since last message
  const isIn24HoursWindow = isBefore(new Date(), date24HoursAfterLatestMessage);

  return isIn24HoursWindow;
};
